export default __webpack_public_path__ + "static/media/Labirynth-06.26d6dfef.svg";